let listeners = {}

let executeHandler = (handler) => {
  try {
    handler()
  } catch (e) {
  }
}

window.addEventListener('keydown', (e) => {
  if (listeners[e.keyCode]) {
    for (let handler of listeners[e.keyCode]) {
      executeHandler(handler)
    }
  }
})

let registerListener = (keycode, handler) => {
  let handlers = listeners[keycode] || []
  handlers.push(handler)
  listeners[keycode] = handlers
}

let removeListeners = () => {
  listeners = {}
}

export default {
  registerListener,
  removeListeners
}
